export default __webpack_public_path__ + "static/media/Vector1.2687bc77.svg";